//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Language } from '@constants'
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue'

const DATA_QUERY = gql`
  query {
    countries(order: [{ name: ASC }], first: 999) {
      nodes {
        id
        name
      }
    }
    regions(order: [{ id: ASC }], first: 999) {
      nodes {
        id
        name
      }
    }
    contentTypes(order: [{ order: ASC }], first: 999, where: { isActive: { eq: true } }) {
      nodes {
        id
        name
      }
    }
    contentCollections(where: { isActive: { eq: true } }, order: [{ order: ASC }], first: 999) {
      nodes {
        id
        name
        slug
      }
    }
  }
`

export default {
  name: 'FilterSidebar',
  components: { ChevronLeftIcon },
  data() {
    return {
      countries: [],
      contentTypes: [],
      contentCollections: [],
      regions: []
    }
  },
  fetchOnServer: true,
  async fetch() {
    this.$store.set('dataFetchingCount/dataFetchingCount', this.$store.get('dataFetchingCount/dataFetchingCount') + 1)
    await this.refresh()
    this.$store.set('dataFetchingCount/dataFetchedCount', this.$store.get('dataFetchingCount/dataFetchedCount') + 1)
  },
  computed: {
    filters: sync('filters'),
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    }
  },
  watch: {
    async languageId() {
      await this.refresh(true)
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    async refresh(purge = false) {
      try {
        const { data } = await this.$apollo.query({
          query: DATA_QUERY,
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        this.countries = data.countries.nodes
        this.contentTypes = data.contentTypes.nodes
        this.contentCollections = data.contentCollections.nodes
        this.regions = data.regions.nodes
      } catch (error) {
        this.handleError(error)
      }
    },
    onBackPress() {
      this.filters.enabled = false
    },
    onFiltersClear() {
      this.filters.options = {
        countryId: null,
        regionId: null,
        contentTypeId: null,
        contentCollectionId: null
      }

      this.$nuxt.$emit('onFiltersClear')
    },
    onFilterCollectionChange() {
      this.$nuxt.$emit('onFilterCollectionChange')
    }
  }
}
